import { render, staticRenderFns } from "./UserDepartmentNew.vue?vue&type=template&id=02bc90b0&scoped=true"
import script from "./UserDepartmentNew.vue?vue&type=script&lang=js"
export * from "./UserDepartmentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc90b0",
  null
  
)

export default component.exports